import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-printable-table",
  imports: [TranslateModule],
  templateUrl: "./printable-table.component.html",
  styleUrl: "./printable-table.component.scss",
})
export class PrintableTableComponent {}
